import React from "react";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import qs from "qs-lite";

import HubCarousel from "../../components/HubCarousel/HubCarousel";
import { useGetAllBarcodes } from "../../hooks";
import { getCarouselLabels } from "./helper";
import { HubButton } from "../../components";

import BarcodeCard from "./BarcodeCard";

export const BarcodesCarousel = ({
  batch = false,
  hideBar = false,
  vertical = false,
  objectType,
  objectId,
}) => {
  const navigate = useNavigate();

  const { data: barcodes, isLoading } = useGetAllBarcodes();

  const labels = getCarouselLabels({ barcodes, objectType });

  const handleClick = (id) => {
    let queryString = "";
    if (objectType && objectId)
      queryString = "?" + qs.stringify({ type: objectType, id: objectId });
    const batchString = batch ? "batch/" : "";
    navigate(`/barcodes/${batchString}${id}${queryString}`);
  };

  return (
    <Stack gap="5px">
      {!hideBar && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="boldCaption">Barcode Templates</Typography>
          <HubButton
            label="Create New Barcode"
            variant="contained"
            size="xsmall"
            page="/barcodes/new"
          />
        </Stack>
      )}
      <Stack direction={vertical ? "column" : "row"} gap="5px" padding="5px">
        {labels?.map(({ id, name, user, time, ...props }) => (
          <BarcodeCard
            key={id}
            id={id}
            onClick={() => handleClick(id)}
            name={name}
            user={user}
            time={time}
            {...props}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default BarcodesCarousel;
